import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../services/FetchNodeServices";

const AddCatalog = () => {
    const [formData, setFormData] = useState({ name: "", file: null });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, files, value } = e.target;

        if (files) {
            setFormData((prev) => ({ ...prev, [name]: files[0] }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const payload = new FormData();
        payload.append("name", formData.name);
        payload.append("file", formData.file);

        try {
            const response = await axiosInstance.post(
                "/api/v1/catalogues/uploadPdf",
                payload,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response.status === 201) {
                toast.success("Catalogue added successfully");
                navigate("/all-catalogue");
            }
        } catch (error) {
            toast.error("Failed to upload");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />

            <div className="bread">
                <div className="head">
                    <h4>Add Catalogue</h4>
                </div>
                <div className="links">
                    <Link to="/all-catalogue" className="add-new">
                        Back <i className="fa-regular fa-circle-left"></i>
                    </Link>
                </div>
            </div>

            <div className="d-form">
                <form className="row g-3" onSubmit={handleSubmit}>

                    <div className="col-md-4">
                        <label className="form-label">Catalogue Name</label>
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Catalogue File (PDF)</label>
                        <input
                            type="file"
                            name="file"
                            accept="application/pdf"
                            className="form-control"
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-md-12 mt-3">
                        <button className="bt" type="submit" disabled={isLoading}>
                            {isLoading ? "Saving..." : "Add Catalogue"}
                        </button>
                    </div>

                </form>
            </div>
        </>
    );
};

export default AddCatalog;
